/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { UitkButtonSize } from 'uitk-react-button';
import FormElement from './form-element';
import GoogleRecaptcha from 'react-google-recaptcha';
import { get } from 'lodash';
import { checkValue, LightenDarkenColor,getLocalizedMessage } from 'src/components/common/helper';
import * as config from 'src/config/config';
import { css } from 'styled-components';
import { MainLayout } from 'src/components/common/common/layout/layout';
import gaLogger from 'src/utils/ga-logger';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';
import { Typo } from 'src/components/common/ui';

// Css Style Import
import(/* webpackChunkName: "v1-entry-form-styles" */ 'src/components/common/modules/v1/entry-form/styles/entry-form.css');

const EntryForm = (props: any) => {
  const [elements, setElements] = useState(null);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [isFormSubmitSuccess, setIsFormSubmitSuccess] = useState(false);

  const isReCAPTCHAOff = checkValue(props?.turnOffReCAPTCHA) && props.turnOffReCAPTCHA.toLowerCase() === 'true';
  
  useEffect(() => {
    const data = {
      ...props,
      view: 'grid',
      pos: String(props.context.site.id),
      locale: props.context.locale,
      module_key: `${props.campaign_name}-${props.uniquekey}`,
      captcha_key: '',
      ggCaptchaErrorMsg: '',
      ggValidateCaptcha: '',
      ggCaptchaExpired: false,
      controllers: props.questions.map((res) => {
        const uniquekey = `${props.uniquekey}-${
          'uniquekey' in res && checkValue(res.uniquekey) ? res.uniquekey : `rand-${Math.random()}`
        }`;
        const isMandatory = res.module === 'entryFormCopyBlock' || (res.module === 'entryFormText' && res.isMandatory) || (res.module === 'entryFormCheckbox' && res.isMandatory) || (res.module === 'entryFormDropdown' && res.isMandatory) || "False";            
      
        const value =
          res.module === 'entryFormCheckbox' ? false : res.module === 'entryFormCopyBlock' ? res.question : '';
        const isValid = true;
        const smallDescription = checkValue(res.smallDescription) ? res.smallDescription : null;

        // Entry form 2 Textbox questions on 1 line
        const question1Uniquekey = `${uniquekey}-question-1`;
        const question2Uniquekey = `${uniquekey}-question-2`;
        const question3Uniquekey = `${uniquekey}-question-3`;
        const question1IsMandatory = `${res.question1 ? res.question1IsMandatory : 'False'}`;
        const question2IsMandatory = `${res.question2 ? res.question2IsMandatory : 'False'}`;
        const question3IsMandatory = `${res.question3 ? res.question3IsMandatory : 'False'}`;
        const question1Value = res.module === 'entryFormMultipleCheckbox' ? false : '';
        const question2Value = res.module === 'entryFormMultipleCheckbox' ? false : '';
        const question3Value = res.module === 'entryFormMultipleCheckbox' ? false : '';
        const question1IsValid = true;
        const question2IsValid = true;
        const question3IsValid = true;

        // Entry form subheading
        const heading = checkValue(res.heading) ? res.heading : null;
        const subheading = checkValue(res.subheading) ? res.subheading : null;

        // Entry form dropdowns
        const options = res.answers?.map((answer) => ({
          optionLabel: answer,
          optionValue: answer,
        }));

        let question;
        if (
          res.module === 'entryFormText' ||
          res.module === 'entryFormDropdown' ||
          res.module === 'entryFormMultipleCheckbox' ||
          res.module === 'entryFormCheckbox'
        ) {
          if (res.module === 'entryFormText' || res.module === 'entryFormDropdown') {
            question = res.subCopy ? (
              <div className="group-label">
                <span dangerouslySetInnerHTML={{ __html: res.question }} />
                <span dangerouslySetInnerHTML={{ __html: res.subCopy }} />
              </div>
            ) : (
              res.question
            );
          } else {          
           question = (
              <div className="group-label">
                <span dangerouslySetInnerHTML={{ __html: res.question }} />
               { res.subCopy ? <span dangerouslySetInnerHTML={{ __html: res.subCopy }} />:null}
              </div>
            ) ;
          }
        } else {
          question = res.question;
        }

        let questionMain;
        if (res.module === 'entryFormMultipleCheckbox') {
          questionMain = res.subCopy ? (
            <div className="group-label">
              <span dangerouslySetInnerHTML={{ __html: res.questionMain }} />
              <span dangerouslySetInnerHTML={{ __html: res.subCopy }} />
            </div>
          ) : (
            <span dangerouslySetInnerHTML={{ __html: res.questionMain }} />
          );
        }

        let question1;
        let question2;
        if (res.module === 'entryFormText2QuestionsOn1Line') {
          question1 = res.subCopy ? (
            <div className="group-label">
              <span dangerouslySetInnerHTML={{ __html: res.question }} />
              <span dangerouslySetInnerHTML={{ __html: res.subCopy }} />
            </div>
          ) : (
            res.question
          );
          question2 = res.subCopy ? (
            <div className="group-label">
              <span dangerouslySetInnerHTML={{ __html: res.question }} />
              <span dangerouslySetInnerHTML={{ __html: res.subCopy }} />
            </div>
          ) : (
            res.question
          );
        }

        let question3;
        if (res.module === 'entryFormMultipleCheckbox') {
          question1 = res.question1 ? <span dangerouslySetInnerHTML={{ __html: res.question1 }} /> : null;
          question2 = res.question2 ? <span dangerouslySetInnerHTML={{ __html: res.question2 }} /> : null;
          question3 = res.question3 ? <span dangerouslySetInnerHTML={{ __html: res.question3 }} /> : null;
        }

        if (res.module === 'entryFormText2QuestionsOn1Line') {
          return {
            ...res,
            question,
            question1Uniquekey,
            question2Uniquekey,
            question1IsMandatory,
            question2IsMandatory,
            question1Value,
            question2Value,
            question1IsValid,
            question2IsValid,
            smallDescription,
            question1,
            question2,
          };
        } else if (res.module === 'entryFormMultipleCheckbox') {
          return {
            ...res,
            questionMain,
            question1Uniquekey,
            question2Uniquekey,
            question3Uniquekey,
            question1IsMandatory,
            question2IsMandatory,
            question3IsMandatory,
            question1Value,
            question2Value,
            question3Value,
            question1IsValid,
            question2IsValid,
            question3IsValid,
            smallDescription,
            question1,
            question2,
            question3,
          };
        } else if (res.module === 'entryFormSubheading') {
          return {
            ...res,
            question,
            heading,
            subheading,
          };
        } else {
          return {
            ...res,
            question,
            uniquekey,
            isMandatory,
            value,
            isValid,
            smallDescription,
            options,
          };
        }
      }),
    };   
    setElements(data);
  }, []);

  const {
    controllers,
    pos,
    locale,
    campaign_name,
    module_key,
    ggCaptchaErrorMsg,
    ggValidateCaptcha,
    captcha_key,
    cTATextColor,
    cTAColor,
  } = elements ?? {};

  useEffect(() => {
    if (isFormValidated) {
      submitFormData();
    }
  }, [isFormValidated]);

  const handleSubmit = (event) => {
    event.preventDefault();
    validateForm();
  };
  const reloadPage = (event) => {
    event.preventDefault();
    checkValue(props?.successEntryCtaUrl) ? window.open(props?.successEntryCtaUrl, '_blank') : window.location.reload();
  };

  const validateForm = () => {
    const newElements = { ...elements };
    newElements.controllers.forEach((controller) => {
      const {
        isMandatory,
        question1IsMandatory,
        question2IsMandatory,
        question3IsMandatory,
        module,
        value,
        question1Value,
        question2Value,
        question3Value,
      } = controller;
     
      switch (module) {
        case 'entryFormCheckbox':
          controller['isValid'] = isMandatory === 'False' ? true : value;
          break;
        case 'entryFormText2QuestionsOn1Line':
          controller['question1IsValid'] = question1IsMandatory === 'False' ? true : question1Value !== '';
          controller['question2IsValid'] = question2IsMandatory === 'False' ? true : question2Value !== '';
          break;
        case 'entryFormMultipleCheckbox':
          if (isMandatory === 'True') {
            if (question1Value || question2Value || question3Value) {
              controller['question1IsValid'] = true;
              controller['question2IsValid'] = true;
              controller['question3IsValid'] = true;
            } else {
              controller['question1IsValid'] = question1Value;
              controller['question2IsValid'] = question2Value;
              controller['question3IsValid'] = question3Value;
            }
          } else {
            controller['question1IsValid'] = true;
            controller['question2IsValid'] = true;
            controller['question3IsValid'] = true;
          }
          break;
        default:
          controller['isValid'] = isMandatory === 'False' ? true : value !== '';
          break;
      }
    });

    let isValidCaptcha = true;
    if (!isReCAPTCHAOff && !checkValue(newElements.captcha_key)) {
      newElements.ggValidateCaptcha = 'invalid';
      newElements.ggCaptchaErrorMsg = getLocalizedMessage(props?.context?.locale?.toLocaleLowerCase(),"validation_error");
      isValidCaptcha = false;
    }
    setElements(newElements);

    const validationChecker = elements.controllers.every((question) => {
      if (question.module === 'entryFormText2QuestionsOn1Line') {
        return question.question1IsValid && question.question2IsValid;
      } else if (question.module === 'entryFormMultipleCheckbox') {       
        return question.isMandatory === 'True'
          ? question.question1IsValid && question.question2IsValid && question.question3IsValid
          : true;
      } else {
        return question.isValid === true;
      }
    });   
    setIsFormValidated(isValidCaptcha && validationChecker);
  };

  const handleChange = (id, e) => {
    const { value, checked } = e.target;
    const newElements = { ...elements };
    newElements.controllers.forEach((controller) => {
      const {
        module,
        uniquekey,
        question1Uniquekey,
        question2Uniquekey,
        question3Uniquekey,
        isMandatory,
        question1IsMandatory,
        question2IsMandatory,
        question3IsMandatory,
      } = controller;

      if (id === uniquekey) {
        switch (module) {
          case 'entryFormCheckbox':
            controller['value'] = checked;
            controller['isValid'] = isMandatory === 'False' ? true : checked;
            break;
          default:
            controller['value'] = value;
            controller['isValid'] = isMandatory === 'False' ? true : value !== '';
            break;
        }
      } else if (id === question1Uniquekey || id === question2Uniquekey || id === question3Uniquekey) {
        if (id === question1Uniquekey) {
          switch (module) {
            case 'entryFormMultipleCheckbox':
              controller['question1Value'] = checked;
              controller['question1IsValid'] = question1IsMandatory === 'False' ? true : checked;
              break;
            default:
              controller['question1Value'] = value;
              controller['question1IsValid'] = question1IsMandatory === 'False' ? true : value !== '';
              break;
          }
        } else if (id === question2Uniquekey) {
          switch (module) {
            case 'entryFormMultipleCheckbox':
              controller['question2Value'] = checked;
              controller['question2IsValid'] = question2IsMandatory === 'False' ? true : checked;
              break;
            default:
              controller['question2Value'] = value;
              controller['question2IsValid'] = question2IsMandatory === 'False' ? true : value !== '';
              break;
          }
        } else {
          controller['question3Value'] = checked;
          controller['question3IsValid'] = question3IsMandatory === 'False' ? true : checked;
        }
      }
      setElements(newElements);
    });
  };

  const submitFormData = async (): Promise<void> => {
    const question = elements.controllers
      .map((controller) => {
        const questions = [];

        function getQuestion(value) {
          if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            if (value.props.children) {
              return value.props.children[0].props.dangerouslySetInnerHTML.__html;
            } else {
              return value.props.dangerouslySetInnerHTML.__html;
            }
          } else {
            return value;
          }
        }

        if (controller.module === 'entryFormText2QuestionsOn1Line') {
          if (controller.question1) {
            questions.push({
              question: getQuestion(controller.question1),
              value: String(controller.question1Value),
            });
          }
          if (controller.question2) {
            questions.push({
              question: getQuestion(controller.question2),
              value: String(controller.question2Value),
            });
          }
        } else if (controller.module === 'entryFormMultipleCheckbox') {
          if (controller.question1) {
            questions.push({
              question: getQuestion(controller.question1),
              value: String(controller.question1Value),
            });
          }
          if (controller.question2) {
            questions.push({
              question: getQuestion(controller.question2),
              value: String(controller.question2Value),
            });
          }
          if (controller.question3) {
            questions.push({
              question: getQuestion(controller.question3),
              value: String(controller.question3Value),
            });
          }
        } else {
          if (
            controller.module === 'entryFormText' ||
            controller.module === 'entryFormDropdown' ||
            controller.module === 'entryFormCheckbox'
          ) {            
            const questionText = controller.question !== '' ? controller.question : controller.prefilledText;            
            questions.push({
              question: getQuestion(questionText),
              value: String(controller.value),
            });
          }
        }

        return questions;
      })
      .flat();

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-type': 'application/json; charset=UTF-8' },
      body: JSON.stringify({
        pos,
        locale,
        captcha_key,
        campaign_name,
        module_key,
        question,
      }),
    };

    await fetch('/capsapi/submitentry?microsites=1', requestOptions)
      .then((response) => response.json())
      .then(() => {
        if (checkValue(props.isQuiz)) {
          gaLogger.logGa('Form', 'Form_Submitted', `Quiz - ${campaign_name} - ${pos}`);
          props.onEntryFormChange && props.onEntryFormChange();
        } else {
          setIsFormSubmitSuccess(true);
          props.scrollToTop && props.scrollToTop();
          gaLogger.logGa('Form', 'Form_Submitted', `${campaign_name} - ${pos}`);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleChangeCaptcha = (captcha_key) => {
    if (captcha_key === null) {
      setElements({ ...elements, captcha_key, ggCaptchaExpired: true, ggValidateCaptcha: 'invalid' });
    } else {
      setElements({
        ...elements,
        captcha_key,
        ggCaptchaExpired: false,
        ggCaptchaErrorMsg: '',
        ggValidateCaptcha: '',
      });
    }
  };

  const asyncScriptOnLoad = () => {
    /* */
  };

  const moduleCss = () => {
    let primaryDarkColor = '';
    if (checkValue(cTAColor)) {
      primaryDarkColor = LightenDarkenColor(cTAColor, -0.1);
    }

    return `
      ${
        checkValue(cTAColor) || checkValue(cTATextColor)
          ? `
        .entry-form-submit {
          ${cTAColor !== '' ? `background-color: ${cTAColor} !important;` : ``} 
          ${cTATextColor !== '' ? `color: ${cTATextColor} !important;` : ``}
        }
        .entry-form-submit:hover {
          ${checkValue(primaryDarkColor) ? `background-color: ${primaryDarkColor} !important;` : ''}
        }
        `
          : ''
      }
      ${
        checkValue(props?.formElementBackgroundColor)
          ? `
          .entryform-input.input-box {
            background-color: ${props.formElementBackgroundColor};
          }
          .uitk-checkbox .uitk-checkbox-control {
            background-color: ${props.formElementBackgroundColor};
          }
        `
          : ''
      }
      ${
        checkValue(props?.textColor)
          ? `
          .uitk-field-select-field .uitk-field-select-icon {
            fill: ${props.textColor}
          }
          .entryform-input.input-box {
            color: ${checkValue(props?.formElementTextColor) ? props.formElementTextColor : props.textColor}
          }
          .entryform-input.input-box {
            border-color: ${props.textColor}
          }
          .entry-form .uitk-field-input:focus {
            border-color: ${props.textColor} !important;
          }
          .uitk-checkbox .uitk-checkbox-control {
            color: ${props.formElementBackgroundColor};
          }
        `
          : ''
      }
      ${
        checkValue(props?.formElementTextColor)
          ? `
          .entryform-input.input-box {
            color: ${checkValue(props?.formElementTextColor) ? props.formElementTextColor : ''}
          }
          `
          : ''
      }
      ${
        checkValue(props?.backgroundImage)
          ? `
          .uitk-checkbox .uitk-checkbox-control {
            background-color: ${props.formElementBackgroundColor}00;
            border-radius: 4px;
            border-color : #ffffff;
          }
          `
          : ''
      }
      ${
        checkValue(props?.formElementPlaceholderTextColor)
          ? `
          .entryform-input.input-box::placeholder {
            color: ${props.formElementPlaceholderTextColor}
          }
          .entryform-input.uitk-field-select.no-selected-value {
            color: ${props.formElementPlaceholderTextColor}
          }
        `
          : ''
      }
    `;
  };

  const primaryButtonProps: PrimaryButtonProps = {
    text: props?.cTAText,
    tag: 'button',
    onClickEvent: (e) => handleSubmit(e),
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Entry Form submit',
      eventLabel: props?.cTAText,
    },
    exClass: `entry-form-submit`,
    size: UitkButtonSize.LARGE,
  };

  const reloadButtonProps: PrimaryButtonProps = {
    text: props?.successEntryCtaText,
    tag: 'button',
    onClickEvent: (e) => reloadPage(e),
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Entry Form reload',
      eventLabel: props?.successEntryCtaText,
    },
    exClass: `entry-form-reload`,
    size: UitkButtonSize.LARGE,
  };

  return (
    <MainLayout
      className="entry-form"
      css={css`
        ${moduleCss()}       
      `}
    >
      {!isFormSubmitSuccess ? (
        <form autoComplete="off">
          <UitkLayoutGrid columns={1} space="six">
            {controllers
              ? controllers.map((controller, i) => {
                  return (
                    <UitkLayoutGridItem key={i}>
                      <div>
                        <FormElement controller={controller} handleChange={handleChange} />
                      </div>
                    </UitkLayoutGridItem>
                  );
                })
              : null}
            {!isReCAPTCHAOff ? (
              <UitkLayoutGridItem className="entry-form__captcha_wrapper">
                <div>
                  <GoogleRecaptcha
                    sitekey={config.config.captureSiteKey}
                    className={`captcha ${ggValidateCaptcha === 'invalid' ? 'error' : ''}`}
                    onChange={handleChangeCaptcha}
                    asyncScriptOnLoad={asyncScriptOnLoad}
                    hl={checkValue(props?.context?.locale) ? get(props?.context?.locale.split('_'), '[0]', 'en') : 'en'}
                  />
                  {ggValidateCaptcha === 'invalid' && (
                    <div className="uitk-validation-error" role="alert" id="emaildemo-error">
                      {ggCaptchaErrorMsg}
                    </div>
                  )}
                </div>
              </UitkLayoutGridItem>
            ) : null}
          </UitkLayoutGrid>
          <div className="entry-form__btn_wrapper">
            <PrimaryButton {...primaryButtonProps} />
          </div>
        </form>
      ) : (
        <>
          <div className="entry-form__success">
            <Typo.HTMLText tag="h3">{props?.successEntryTitle}</Typo.HTMLText>
            <Typo.HTMLText tag="p">{props?.successEntryCopy}</Typo.HTMLText>
            {checkValue(props?.successEntryCtaText) && (
              <div className="entry-form__btn_wrapper">
                <PrimaryButton {...reloadButtonProps} />
              </div>
            )}
          </div>
        </>
      )}
    </MainLayout>
  );
};

export default EntryForm;
